import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Making a Möbius cake",
  "description": "",
  "published": "2011-10-30T00:00:00.000Z",
  "redirect_from": ["/blog/making-a-mobius-cake/ponywithhiccups/2737"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a guest post by `}<a parentName="em" {...{
          "href": "http://twitter.com/ponywithhiccups"
        }}>{`@ponywithhiccups`}</a>{`, a cool gal who sometimes makes epic nerdy cakes.`}</em></p>
    <p>{`It was a simple deal: Swizec would make a cake for me and I would make a cake for him. After many many not so subtle hints I got `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-technical-post-about-cake/swizec/2626",
        "title": "A technical post about cake"
      }}>{`exactly what I wanted`}</a>{`.`}</p>
    <p>{`He wanted this in a cake form -->`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/MoebiusGearA-300x226.jpg",
        "alt": null
      }}></img></p>
    <p>{`Ignoring the gears I was eager to make the complicated cake, how hard could it be?`}</p>
    <p>{`I've heard of möbius architecture so it wasn't like I was the first person making a 3D mobius strip able to stand on its own. A quick google search and there it was: a nice picture of a 3D model. Yay, I could actually do this!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/twisted_33.png",
        "alt": null
      }}></img></p>
    <p>{`It looked simple enough at first, just cut a hole in cake dough, then cut it in half and bend it a little - voila done! But then I started thinking and soon realised you can't just bend a cake. The cake dough is not a bendy material; it is actually very brittle and sensitive and not cooperative at all! And what would happen tho the fill if the layers were vertical and not horizontal and how the heck do you cut a cake like that? Nope, the layers have to be horizontal. And there was my first big problem - the cake layers were not simple shapes anymore.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/MOBIUS-CAKE_00031-1024x878.jpg",
        "alt": "first sketch",
        "title": "MOBIUS CAKE_0003"
      }}></img></p>
    <h2 {...{
      "id": "3d-modeling-to-the-rescue"
    }}>{`3D modeling to the rescue!`}</h2>
    <p>{`Just looking at the pretty picture of möbius arhitecture didn't tell me how to cut. I had to figure that bit out on my own. Since I'm too lazy to do things by hand I did it on a computer.`}</p>
    <p>{`After some trial and error and a lot of clumsy modeling things started making sense. It turns out a 3D möbius structure is just two möbius strips intertwined or a square making half a rotation along a circular path.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/cad2.jpg",
        "alt": null,
        "title": "cad2"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/cad1.jpg",
        "alt": null,
        "title": "cad1"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/fatty.jpeg",
        "alt": null,
        "title": "fatty"
      }}></img></p>
    <p>{`All I needed to do now was to cut the virtual cake in layers.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/cuts4.jpeg",
        "alt": null,
        "title": "cuts4"
      }}></img></p>
    <p>{`Now that I knew what the layers would look like all I could think was `}<em parentName="p">{`"I wish I could `}<a parentName="em" {...{
          "href": "http://www.neatorama.com/2011/07/20/mobius-cake/"
        }}>{`3d print cake`}</a>{`!"`}</em></p>
    <h2 {...{
      "id": "the-cakeday"
    }}>{`The cakeday`}</h2>
    <p>{`I was making a yummy chocolate cake with sour cherries in the middle! So even if it turned out horribly deformed it would still be tasty, just look at the ingredients!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2011-10-28-12-43-18-131.jpg",
        "alt": null,
        "title": "2011-10-28-12-43-18-131"
      }}></img></p>
    <p>{`It all started pretty normal: heating, mixing, cooling, etc. and then came the time to cut the bisquit, the moment I did not look forward to. With the help of a ruler, a compass and colorful pencils I soon had a cutting template.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/IMG719-768x1024.jpg",
        "alt": null,
        "title": "IMG719"
      }}></img></p>
    <p>{`And there I was: a sharp knife in my right and a paper template in my left, ready to make a mess.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/IMG718-1024x768.jpg",
        "alt": null,
        "title": "IMG718"
      }}></img></p>
    <p>{`And it got messy fast, the bisquit is very crumbly. Not my favourite material at all!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2011-10-28-16-49-43-336.jpg",
        "alt": null,
        "title": "2011-10-28-16-49-43-336"
      }}></img></p>
    <p>{`It was during the process of cutting the first layer when I had the what-the-hell-am-i-even-doing moment. The first layer looked like a giant crooked eye and it almost fell apart when i moved it. And it wasn't getting any better.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2011-10-28-17-08-44-674.jpg",
        "alt": null,
        "title": "2011-10-28-17-08-44-674"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2011-10-28-17-53-59-968.jpg",
        "alt": null,
        "title": "2011-10-28-17-53-59-968"
      }}></img></p>
    <p>{`The chocolate fill was almost liquid, the cherries decided it was time to run away, the cake did not look like a mobius cake at all! I opened the windows to make the whole kitchen a giant cooler and hoped for the best.`}</p>
    <p>{`Then I just kept adding a metric fuckton of chocolate.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/IMG725-1024x768.jpg",
        "alt": null,
        "title": "IMG725"
      }}></img></p>
    <p>{`And i did it!`}</p>
    <p>{`It was not pretty, it was not elegant, not even slightly symetric, but it was a möbius cake!`}</p>
    <p>{`And I still had a lot of leftover material, so I made a tiny surprise gear cake ;)`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltsgrvEsBK1qekjngo1_5002.jpg",
        "alt": null,
        "title": "It's not a mobius gear cake, but a mobius + gear cake"
      }}></img></p>
    <p><em parentName="p">{`Note from Swizec: It was fucking delicious!`}</em></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.neatorama.com/2011/07/20/mobius-cake/"
        }}>{`Möbius Cake`}</a>{` (neatorama.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://cathweber.blogspot.com/2011/10/epic-cake-disaster.html"
        }}>{`an epic cake disaster`}</a>{` (cathweber.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.core77.com/blog/videos/mobius_a_stop-motion_sculpture_by_eness_20194.asp"
        }}>{`"MOBIUS," a Stop-Motion Sculpture by ENESS`}</a>{` (core77.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://letsplaymath.net/2011/09/21/moebius-noodles-photo-game/"
        }}>{`Moebius Noodles Photo Game`}</a>{` (letsplaymath.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1995dbbb-ce88-41c7-9ca3-7c3aa9fdeeb4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      